import { PALETTE } from '../../common/styles/palette';

export const styles = (theme: any) => {
    return {
        SearchContainer: {
            display: 'flex',
            alignItems: 'center'
        },
        searchButtons: {
            width: '100%',
            paddingLeft: '10px',
            display: 'flex'
        },
        searchButton: {
            marginLeft: '10px',
            marginRight: '10px',
        },
        SearchSection: {
            display: 'flex',
            alignItems: 'center'
        },
        tag: {
            "&:hover": {
                cursor: "pointer"
            }
        },
        tagSelected: {
            backgroundColor: PALETTE.Contacts.List.SelectedContact.BackGroundColor
        },
        detailSample: {
            display: 'flex',
            padding: '5px',
            alignContent: 'center',
            margin: '10px',
            backgroundColor: '#efefef'
        },
        detailSampleText: {
            paddingLeft: '20px',
        },
        textColorRadioGroup: {
            paddingLeft: '10px',
            border: '1px solid black',
            width: 'fit-content'
        },
        colorSection: {
            marginTop: '20px'
        },
        colorSectionItem: {
            marginTop: '10px'
        },
        detailButtonsContainer: {
            display: 'flex',
            justifyContent: 'flex-end',
            padding: '0px 10px 10px 0px'
        },
        contactCount: {
            display: 'flex',
            alignItems: 'center'
        },
        followersHeader: {
            display: 'flex',
            alignItems: 'center',
            padding: '10px'
        },
        tableHeader: {
            backgroundColor: PALETTE.UI.TablesHeader.BackgroundColor,
            display: 'flex',
            alignItems: 'center',
            paddingTop: '2px',
            paddingBottom: '2px',
            paddingLeft: '10px',
            paddingRight: '10px',
        },
        table: {
            display: 'flex',
            alignItems: 'center',
            paddingTop: '2px',
            paddingBottom: '2px',
            paddingLeft: '10px',
            paddingRight: '10px',
        },
        tableHeaderCell: {
            display: 'flex',
            alignItems: 'center',
        },
        detailHeaderText: {
            paddingLeft: '0px'
        },
        tagIcon: {
            minWidth: '0px',
            paddingRight: '10px'
        }
    }
}